// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* import the required JSAPI css */
.esri-view {
  height: 500px;
}

.center {
  position: relative;
  bottom: 35px;
  left: 5px;
  width: 35px;
}

.center ::ng-deep .mat-mdc-progress-spinner circle, .mat-mdc-progress-spinner circle {
  stroke: #000000;
  position: relative;
  bottom: 60px;
  left: 5px;
}

.esri-view:fullscreen {
  width: 100vw !important;
  height: 100vh !important;
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: 10000;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
